import React, { CSSProperties } from 'react';
import { Flex, Box } from '@cad-arc';
import { colors } from '../../colors/colors';

export const PanelOverlay: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Flex
        position="fixed"
        w="100%"
        h="90%"
        top="40px"
        justify="center"
        align="center"
        direction="column"
        zIndex="10000"
    >
        {children}
    </Flex>
);

export const Modal: React.FC<{ style?: CSSProperties; children: React.ReactNode }> = ({
    children,
    style,
}) => (
    <Flex
        maxWidth="800px"
        maxHeight="400px"
        minWidth="540px"
        border="1px solid var(--arc-colors-border-default)"
        backgroundColor="surface.foreground"
        borderRadius="5px"
        boxShadow={`${colors.panelModalBoxShadow} 0px 0px 19px`}
        boxSizing="border-box"
        direction="column"
        shrink={1}
        style={style}
    >
        {children}
    </Flex>
);

export const Header: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Flex
        w="100%"
        justify="space-between"
        padding="7px 10px"
        textAlign="left"
        borderBottom="sm"
        borderColor="border.default"
        fontWeight="600"
        boxSizing="border-box"
    >
        {children}
    </Flex>
);

export const HeaderText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Box padding="7px 10px" textAlign="left" fontWeight="600">
        {children}
    </Box>
);

export const Content: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Box overflow="auto" padding="20px" textAlign="left">
        {children}
    </Box>
);

export const Footer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Box flex="0" padding="20px" textAlign="left" borderTop="sm" borderColor="border.default">
        {children}
    </Box>
);
